import React from 'react'
import { CookieConsentUserSettingsPage } from './CookieConsentUserSettingsPage'
import { createRegisterableComponent } from '@news-mono/web-common'

export const CookieConsentUserSettingsPageRegistration = createRegisterableComponent(
    'cookie-consent-user-settings-page',
    () => <CookieConsentUserSettingsPage />,
)
